export default __webpack_public_path__ + "static/media/Staycation.317fd1f5.png";